import React from 'react';

const Section = ({title, children}) => (
  <section style={{marginBottom:28}}>
    <h3 style={{color:'#c9a62b',marginBottom:8}}>{title}</h3>
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
      {children}
    </div>
  </section>
);

export default function NamingFamily(){
  return (
    <div className="container">
      <main style={{padding:20,maxWidth:980,margin:'0 auto'}}>
        <h2 style={{color:'#e6c869',marginTop:12}}>The JK Legacy Naming Family</h2>
        <p style={{color:'#bdbdbd'}}>A curated naming system for properties, trusts and projects under the JK umbrella. Use these names across gates, documents and boards.</p>

        <Section title="1. Main Identity (Umbrella Brand)">
          <div>JK Avenue</div>
          <div>JK Legacy</div>
          <div>JK Estates</div>
          <div>JK Crown</div>
          <div>House of JK</div>
        </Section>

        <Section title="2. Residential Houses / Villas / Bungalows">
          <div><strong>JK Manor</strong><div style={{color:'#bdbdbd'}}>Traditional, royal — Heritage homes</div></div>
          <div><strong>JK Nivas</strong><div style={{color:'#bdbdbd'}}>Tamil/Sanskrit blend — Family residence</div></div>
          <div><strong>JK Palace</strong><div style={{color:'#bdbdbd'}}>Majestic & powerful — Large bungalows</div></div>
          <div><strong>JK Villa</strong><div style={{color:'#bdbdbd'}}>Modern and classy — Gated villa properties</div></div>
          <div><strong>JK Mahal</strong><div style={{color:'#bdbdbd'}}>Regal Tamil vibe — Lineage homes</div></div>
          <div><strong>JK Enclave</strong><div style={{color:'#bdbdbd'}}>Gated private villas — Residential layouts</div></div>
        </Section>

        <Section title="3. Agricultural Land / Farms / Nature Properties">
          <div><strong>JK Greens</strong><div style={{color:'#bdbdbd'}}>Nature + modern feel — Organic farming land</div></div>
          <div><strong>JK Vanam</strong><div style={{color:'#bdbdbd'}}>Tamil for forest — Agroforestry/eco-farm</div></div>
          <div><strong>JK Bhoomi</strong><div style={{color:'#bdbdbd'}}>Sanskrit rooted — Cultivable lands</div></div>
          <div><strong>JK Meadows</strong><div style={{color:'#bdbdbd'}}>Soft, luxurious — Agro-villa plots</div></div>
          <div><strong>JK Harvests</strong><div style={{color:'#bdbdbd'}}>Productive sounding — Yield-based lands</div></div>
          <div><strong>JK Farmscape</strong><div style={{color:'#bdbdbd'}}>Futuristic farm brand — Agribusiness</div></div>
        </Section>

        <Section title="4. Apartments / Multi-Unit Buildings">
          <div><strong>JK Heights</strong><div style={{color:'#bdbdbd'}}>Modern and vertical — High-rise apartments</div></div>
          <div><strong>JK Residency</strong><div style={{color:'#bdbdbd'}}>Standard & polished — Mid-rise flats</div></div>
          <div><strong>JK Habitat</strong><div style={{color:'#bdbdbd'}}>Urban & clean — Premium apartments</div></div>
          <div><strong>JK Altura</strong><div style={{color:'#bdbdbd'}}>Latin-inspired — Elite apartment brand</div></div>
          <div><strong>JK Urban</strong><div style={{color:'#bdbdbd'}}>Contemporary — City-focused projects</div></div>
        </Section>

        <Section title="5. Holdings / Legal Entity / Business & Trust">
          <div><strong>JK Holdings</strong><div style={{color:'#bdbdbd'}}>Umbrella business / family entity</div></div>
          <div><strong>JK Legacy Trust</strong><div style={{color:'#bdbdbd'}}>Inheritance and property trust</div></div>
          <div><strong>JK Realty</strong><div style={{color:'#bdbdbd'}}>Real estate arm</div></div>
          <div><strong>JK Capital</strong><div style={{color:'#bdbdbd'}}>Finance or investment wing</div></div>
          <div><strong>JK Dynasty Group</strong><div style={{color:'#bdbdbd'}}>For long-term lineage</div></div>
          <div><strong>JK Foundation</strong><div style={{color:'#bdbdbd'}}>Philanthropy / charity</div></div>
        </Section>

        <Section title="6. Layouts / Private Roads / Gated Areas">
          <div><strong>JK Gardens</strong><div style={{color:'#bdbdbd'}}>Elegant gated area</div></div>
          <div><strong>JK Royal Enclave</strong><div style={{color:'#bdbdbd'}}>Premium housing layout</div></div>
          <div><strong>JK Estate Park</strong><div style={{color:'#bdbdbd'}}>Central family layout</div></div>
          <div><strong>JK Crescent</strong><div style={{color:'#bdbdbd'}}>Classy cul-de-sac</div></div>
          <div><strong>JK Grove</strong><div style={{color:'#bdbdbd'}}>Villa plots + greenery</div></div>
          <div><strong>JK Serenity</strong><div style={{color:'#bdbdbd'}}>Peaceful community name</div></div>
        </Section>

        <Section title="7. Special Themed Properties">
          <div><strong>JK Nirvana</strong><div style={{color:'#bdbdbd'}}>Spiritual retreat, ashram-style lands</div></div>
          <div><strong>JK Heritage</strong><div style={{color:'#bdbdbd'}}>Restored ancestral buildings</div></div>
          <div><strong>JK Horizon</strong><div style={{color:'#bdbdbd'}}>Future-looking property brand</div></div>
          <div><strong>JK Sanctuary</strong><div style={{color:'#bdbdbd'}}>Private farm, wildlife, retreat land</div></div>
          <div><strong>JK Bloom</strong><div style={{color:'#bdbdbd'}}>Gardened villas / nature-rich homes</div></div>
        </Section>

        <section style={{marginTop:18}}>
          <h4 style={{color:'#c9a62b'}}>Usage examples</h4>
          <ul style={{color:'#bdbdbd'}}>
            <li>Ancestral house — JK Nivas</li>
            <li>Coconut farmland — JK Vanam</li>
            <li>Gated villa layout — JK Royal Enclave</li>
            <li>Upcoming apartment — JK Heights</li>
            <li>Family trust — JK Legacy Trust</li>
            <li>Company registry — JK Holdings</li>
            <li>Modern city home — JK Residency</li>
            <li>Grand private road — JK Avenue</li>
          </ul>
        </section>

      </main>
    </div>
  );
}
